import { useMutation } from '@tanstack/react-query';

import cycleEvaluatorSelectionService from './cycleEvaluatorSelectionService';

import type {
    CycleEvaluatorSelection,
    CycleEvaluatorSelectionUpdate,
} from '@/types/cycle-evaluation/CycleEvaluatorSelection';

import { queryClient } from '@/AppWithProviders';
import { CycleEvaluationQueryKey } from '@/constants/QueryKeys';

const useUpdateCycleEvaluatorSelection = () => {
    return useMutation<CycleEvaluatorSelection, Error, CycleEvaluatorSelectionUpdate>({
        mutationFn: (cycleEvaluationSelection: CycleEvaluatorSelectionUpdate) =>
            cycleEvaluatorSelectionService.updateCycleEvaluatorSelection(cycleEvaluationSelection),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [CycleEvaluationQueryKey.CYCLE_EVALUATION],
            });
        },
    });
};

export { useUpdateCycleEvaluatorSelection };
